import React from "react"
import { Box } from "@carrotfertility/carotene-core"
import { BookingBreadcrumbs } from "../../Breadcrumbs"
import { BookingCard } from "../BookingCard"

export function InsuranceLayout({ children }: React.PropsWithChildren): JSX.Element {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(theme.tokens.spacing.lg),
        inlineSize: "100%",
        maxInlineSize: 640
      })}
    >
      <BookingBreadcrumbs />
      <BookingCard>{children}</BookingCard>
    </Box>
  )
}
